import * as React from 'react'
import SVG from 'react-inlinesvg'
import { ModalType } from '@App/store/modal'

import CLOSE_ICON from 'assets/close-icon.svg'
import 'components/blocks/Modal/style.scss'

class HeaderModal extends React.Component<any> {
  render() {
    const { type, onClose } = this.props
    return (
      <div
        role="button"
        className="closeButton"
        onClick={onClose}
      >
        <SVG src={CLOSE_ICON} />
        {type !== ModalType.DELETE && (
          <p>Esc</p>
        )}
      </div>
    )
  }
}

export default HeaderModal
